<div class="bids-live">
  <header class="bids-live__header">
    <h3 class="bids-live__title">{{ 'auctions.liveBiddingLog' | translate }}</h3>
    <span class="bids-live__feed-badge">
      <span class="bids-live__feed-dot"></span>
      {{ 'auctions.realTimeFeed' | translate }}
    </span>
  </header>

  @if (bidEntries().length > 0) {
    <ul class="bids-live__list custom-scrollbar">
      @for (entry of bidEntries(); track entry.id) {
        <li
          class="bids-live__item"
          [class.bids-live__item--leading]="entry.isLeading"
          [class.bids-live__item--base]="entry.isBasePrice">
          <span
            class="bids-live__avatar"
            [class.bids-live__avatar--leading]="entry.isLeading"
            [class.bids-live__avatar--base]="entry.isBasePrice">
            {{ entry.initial }}
          </span>

          <div class="bids-live__info">
            <p class="bids-live__name">{{ entry.name }}</p>
            @if (!entry.isBasePrice && entry.createdAt) {
              <p class="bids-live__time">
                <i class="iconsax" icon-name="clock"></i>
                {{ getRelativeTime(entry.createdAt) }}
              </p>
            }
          </div>

          <div class="bids-live__amount-block">
            <p
              class="bids-live__amount"
              [class.bids-live__amount--leading]="entry.isLeading">
              {{ currencyToSymbol(auction()?.currency) }}{{ entry.price | number }}
            </p>
            @if (!entry.isBasePrice) {
              <span
                class="bids-live__status"
                [class.bids-live__status--leading]="entry.isLeading">
                {{ 'auctions.outbid' | translate }}
              </span>
            }
          </div>
        </li>
      }
    </ul>
  } @else {
    <p class="bids-live__empty">{{ 'auctions.noLiveBids' | translate }}</p>
  }
</div>
